import React from "react";
// import ExceedPlus from "../controls/exceed-plus";
import Tag from "../controls/tag";
import ValidatePerms from "./validate-perms";

class TagsContainer extends React.Component {
  // constructor(props) {
  //   super(props);

  //   this.state = {
  //     tags: props.tags || [],
  //     labels: props.labels || [],
  //     onClick: props.onClick || (() => { }),
  //     title: props.title || ''
  //   };

  // }

  render() {

    let hideEditBtn = this.props.hideEditBtn ?? false

    return (
      <div className="tags-content">
        <div style={{ display: "flex" }}>
          <div className="title">{this.props.title}</div>
          {
            !hideEditBtn && 
            <ValidatePerms perms={this.props.permsEditBtn}>
              <img
                alt=""
                src="/images/edit-transparent.svg"
                className="edit-image"
                onClick={this.props.onClick}
              />
            </ValidatePerms>
          }
        </div>
        {this.props.tags.length > 0 && (
          <ValidatePerms perms={this.props.permsContent}>
            <div
              className="container"
              style={{
                height:
                  this.props.labels.length > 0
                    ? "calc(40% - 25px)"
                    : "calc(100% - 40px)"
              }}
            >
              {/* <ExceedPlus
              name={this.props.name}
              className='wrap'
              maxVisibleItems={(this.props.labels.length > 0) ? 3 : 5} > */}
              {this.props.tags.map(tag => (
                <Tag
                  key={tag.id}
                  id={tag.id}
                  title={tag.title}
                  color={tag.color}
                />
              ))}
              {/* </ExceedPlus> */}
            </div>
          </ValidatePerms>
        )}
        {this.props.labels.length > 0 && (
          <React.Fragment>
            {this.props.tags.length > 0 && <div className="line" />}

            <div
              className="container"
              style={{
                height:
                  this.props.labels.length > 0 && this.props.tags.length > 0
                    ? "calc(60% - 25px)"
                    : "calc(100% - 40px)"
              }}
            >
              {this.props.labels.map((item, index) => {
                return index === 0 ? (
                  <span key={index} className="label">
                    {item}
                  </span>
                ) : (
                  <span key={index} className="label">
                    {", " + item}
                  </span>
                );
              })}
            </div>
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default TagsContainer;

TagsContainer.defaultProps = {
  tags: [],
  labels: [],
  onClick: () => {},
  title: ""
};
